import React, { Component } from 'react';
import ComponentOregistapp from '../oregistapp/Index';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="mb16" id="custom">
        <ComponentOregistapp {...this.props} pageSize={10} incuUuid={this.props.params.uuid} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageOregistapp.js